import BaseModel from '../core/BaseModel';
import UserModel from '@/models/UserModel';

export default class NewsCategoryModel extends BaseModel {
  constructor() {
    super(
      {
        name: 'news_category',
        tableName: 'news_category',
        label: 'News Category',
        display_key: 'name',
      },
      {
        stt: {
          name: 'stt',
          label: 'No.',
          type: 'Computed',
          computed: (data, index) => {
            data.stt = index + 1;
          },
          class: 'left',
        },

        id: {
          name: 'id',
          type: 'Uuid',
          label: 'ID',
          primaryKey: true,
          display: false,
        },

        name: {
          name: 'name',
          type: 'String',
          label: 'Name',
          filter: { type: 'input', match: 'contains' },
          class: 'left',
        },

        ordinal: {
          name: 'ordinal',
          type: 'Number',
          label: 'Order',
          width: 10,
          class: 'left',
        },

        active: {
          name: 'active',
          label: 'Active',
          type: 'Selection',
          custom: 'SelectionText',
          options: [
            { value: 'true', label: 'Yes', style: 'color:  #000000;' },
            { value: 'false', label: 'No', style: 'color:  #000000;' },
          ],
          filter: {
            type: 'select',
            optionLabel: 'label',
            optionKey: 'value',
            match: 'equals',
          },
          class: 'active-css',
          width: 8,
        },

        created_at: {
          name: 'created_at',
          type: 'Datetime',
          label: 'Created At',
          display: false,
        },

        created_by: {
          name: 'created_by',
          type: 'Uuid',
          label: 'Created By',
          display: false,
        },

        updated_by: {
          name: 'updated_by',
          type: 'Uuid',
          label: 'Updated By',
          display: false,
        },

        updated_by_key: {
          name: 'updated_by_key',
          label: 'Updated by',
          type: 'Computed',
          models: new UserModel(),
          computed: (data) => {
            data.updated_by_key = '';
          },
          class: 'left',
          width: 20,
        },

        updated_at: {
          name: 'updated_at',
          type: 'String',
          label: 'Updated date',
          width: 20,
          class: 'left',
        },

        deleted: {
          name: 'deleted',
          type: 'Boolean',
          label: 'Deleted',
          display: false,
        },

        type_category: {
          name: 'type',
          type: 'Number',
          label: 'Type category',
          display: false,
        },
      }
    );
  }
}
